import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import BaseLayout from './BaseLayout';
import KioskTable from '../KioskTable';
import Storage from '../../Storage';
import { browserHistory } from 'react-router';
import KioskDeploymentSetTable from '../KioskDeploymentSetTable';
import BatchActionHistoryTable from '../BatchActionHistoryTable';
import * as actions from '../../redux/actions';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import KioskUpdateStep1 from '../KioskUpdateStep1';
import KioskTagging from '../KioskTagging';
import KioskDelete from '../KioskDelete';
import KioskDeploymentSetUpdate from '../KioskDeploymentSetUpdate';
import kioskPackageUpdate from '../KioskPackageUpdate';
import ReactSpinner from 'react-spinjs';
import KioskPackageUpdate from '../KioskPackageUpdate';

class KioskPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inProgress: false,
      modalView: '',
      selectedIndex: this.calcTabIndexFromUrlPath(),
    };
    this.onBrowserHistoryChange = this.onBrowserHistoryChange.bind(this);
    this.handleShowUpdateKiosksModal = this.handleShowUpdateKiosksModal.bind(this);
    this.handleShowDeleteKiosksModal = this.handleShowDeleteKiosksModal.bind(this);
    this.handleShowUpdateKioskPackageModal = this.handleShowUpdateKioskPackageModal.bind(this);
    this.handleShowBatchActionPage = this.handleShowBatchActionPage.bind(this);
    this.handleShowTaggingModal = this.handleShowTaggingModal.bind(this);
    this.handleShowDeploymentSetUpdateModal = this.handleShowDeploymentSetUpdateModal.bind(this);
    this.handleDeleteKiosks = this.handleDeleteKiosks.bind(this);
    this.handleTagKiosks = this.handleTagKiosks.bind(this);
    this.handleUpdateDeploymentSet = this.handleUpdateDeploymentSet.bind(this);
    this.handleUpdatePatchDateAndTime = this.handleUpdatePatchDateAndTime.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  onBrowserHistoryChange() {
    let { location } = this.props;
    // when browser back button is pressed
    if (location.action === 'POP' && !this.unmounted) {
      this.handleSelect(this.calcTabIndexFromUrlPath());
    }
  }

  componentDidMount() {
    this.handleSelect(this.calcTabIndexFromUrlPath());
    this.unsubscribeBrowserHistoryChange = browserHistory.listen(this.onBrowserHistoryChange);
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.unsubscribeBrowserHistoryChange) {
      this.unsubscribeBrowserHistoryChange();
    }
  }

  calcTabIndexFromUrlPath() {
    let pathname = this.props.location.pathname;
    let index = 1; // default to '/kiosk/adm'
    switch (pathname) {
      case '/kiosk/all':
        index = 0;
        break;
      case '/kiosk/adm':
        index = 1;
        break;
      case '/kiosk/adm/in/local':
        index = 2;
        break;
      case '/kiosk/adm/he/colo':
        index = 3;
        break;
      case '/kiosk/deployment/set':
        index = 4;
        break;
      case '/kiosk/batch/actionhistory':
        index = 5;
        break;
    }
    return index;
  }

  async handleShowUpdateKiosksModal() {
    const { dispatch } = this.props;
    dispatch(actions.getKVSList());
    this.setState({ modalView: 'updateStep1' });
  }

  async handleShowDeleteKiosksModal() {
    this.setState({ modalView: 'kioskDelete' });
  }

  async handleShowUpdateKioskPackageModal() {
    this.setState({ modalView: 'packageUpdate' });
  }

  async handleShowBatchActionPage() {
    browserHistory.push('/kiosk/batch/action');
  }

  async handleDeleteKiosks() {
    this.setState({ modalView: '', inProgress: true }, async () => {
      const { dispatch, selectedHostInfoList } = this.props;
      for (let hostInfo of selectedHostInfoList) {
        try {
          await dispatch(actions.deleteHostInfo(hostInfo.id));
        } catch (e) {
          alert("Failed to delete hostinfo with ipaddr: " + hostInfo.ip
              + " id: " + hostInfo.id + "!" + "\n" + e.message);
        }
      }
      this.setState({ inProgress: false });
    });
  }

  async handleTagKiosks(tag) {
    this.setState({ modalView: '', inProgress: true }, async () => {
      const { dispatch, selectedHostInfoList } = this.props;
      for (let hostInfo of selectedHostInfoList) {
        try {
          await dispatch(actions.updateKioskTag(hostInfo, tag));
        } catch (e) {
          alert("Failed to update tag: " + tag
              + " in sosdb.kiosk for " + hostInfo.kioskName + "!" + "\n" + e.message);
        }
      }
      this.setState({ inProgress: false });
    });
  }

  async handleUpdateDeploymentSet(deploymentSet = '') {
    this.setState({ modalView: '', inProgress: true }, async () => {
      const { dispatch, selectedHostInfoList } = this.props;
      for (let hostInfo of selectedHostInfoList) {
        try {
          await dispatch(actions.updateKioskDeploymentSet(hostInfo, deploymentSet));
        } catch (e) {
          alert("Failed to update deploymentset: " + deploymentSet
              + " in sosdb.kiosk for " + hostInfo.kioskName + "!" + "\n" + e.message);
        }
      }
      this.setState({ inProgress: false });
    });
  }

  async handleUpdatePatchDateAndTime(patchDate, patchTime) {
    this.setState({ modalView: '', inProgress: true }, async () => {
      const { dispatch, selectedHostInfoList } = this.props;
      const kioskNames = selectedHostInfoList.map((kiosk) => kiosk.kioskName).join(',');
      try {
        await dispatch(actions.updatePatchDateAndTime(kioskNames, patchDate, patchTime));
      } catch (e) {
        alert("Failed to update patch date and time: " + patchDate + " " + patchTime
            + " in sosdb.sfecfg for the selected Kiosks!" + "\n" + e.message);
      }
      this.setState({ inProgress: false });
    });
  }

  async handleShowTaggingModal() {
    this.setState({ modalView: 'tagging' });
  }

  async handleShowDeploymentSetUpdateModal() {
    this.setState({ modalView: 'deploymentset' });
  }

  handleCloseModal(e) {
    this.setState({ modalView: '' });
  }

  handleSelect(index, last) {
    this.setState({ selectedIndex: index }, () => {
      switch (index) {
        case 0:
          Storage.setTabPathname('kiosk', '/kiosk/all');
          break;
        case 1:
          Storage.setTabPathname('kiosk', '/kiosk/adm');
          break;
        case 2:
          Storage.setTabPathname('kiosk', '/kiosk/adm/in/local');
          break;
        case 3:
          Storage.setTabPathname('kiosk', '/kiosk/adm/he/colo');
          break;
        case 4:
          Storage.setTabPathname('kiosk', '/kiosk/deployment/set');
          break;
        case 5:
          Storage.setTabPathname('kiosk', '/kiosk/batch/actionhistory');
          break;
      }
      browserHistory.push(Storage.getTabPathname('kiosk'));
    });
  }

  render() {
    const { inProgress, modalView } = this.state;

    let allKiosks = this.props.hostInfoList.filter((h) => {
      return h.hasKioskInfo;
    });
    let admKiosks = this.props.hostInfoList.filter((h) => {
      return h.hasSosdbKiosk;
    });
    let inLocalAdmKiosks = this.props.hostInfoList.filter((h) => {
      return h.hasSosdbKiosk && h.inLocalStatus;
    });
    let heColoAdmKiosks = this.props.hostInfoList.filter((h) => {
      return h.hasSosdbKiosk && h.kskcfgUsingHEColoProdServerUrl;
    });

    let modalComponent = null;

    switch (modalView) {
      case 'updateStep1':
        modalComponent = <KioskUpdateStep1 {...this.props} onCancel={this.handleCloseModal} />;
        break;
      case 'kioskDelete':
        modalComponent = (
          <KioskDelete
            {...this.props}
            onCancel={this.handleCloseModal}
            onDone={this.handleDeleteKiosks}
          />
        );
        break;
      case 'tagging':
        modalComponent = (
          <KioskTagging
            {...this.props}
            onCancel={this.handleCloseModal}
            onDone={this.handleTagKiosks}
          />
        );
        break;
      case 'deploymentset':
        modalComponent = (
          <KioskDeploymentSetUpdate
            {...this.props}
            onCancel={this.handleCloseModal}
            onDone={this.handleUpdateDeploymentSet}
          />
        );
        break;
      case 'packageUpdate':
        modalComponent = (
          <KioskPackageUpdate
            {...this.props}
            onCancel={this.handleCloseModal}
            onDone={this.handleUpdatePatchDateAndTime}
          />
        );
        break;
    }

    return (
      <BaseLayout {...this.props} selectedTabName='kiosk' style={{ position: 'relative' }}>
        {inProgress && <ReactSpinner />}
        <Tabs onSelect={this.handleSelect.bind(this)} selectedIndex={this.state.selectedIndex}>
          <TabList style={{ textAlign: 'center' }}>
            <Tab><i className='fa fa-fw fa-desktop' />All Kiosks</Tab>
            <Tab><i className='fa fa-fw fa-desktop' />ADM Kiosks</Tab>
            <Tab><i className='fa fa-fw fa-desktop' />ADM Kiosks (In Local)</Tab>
            <Tab><i className='fa fa-fw fa-desktop' />ADM Kiosks (Non-AWS ServerUrl)</Tab>
            <Tab><i className='fa fa-fw fa-building-o' />Kiosk Deployment Set</Tab>
            <Tab><i className='fa fa-fw fa-building-o' />Batch Action History</Tab>
          </TabList>
          <TabPanel>
            <KioskTable
              {...this.props}
              tableTitle='All Kiosks'
              onUpdateKiosks={this.handleShowUpdateKiosksModal}
              onDeleteKiosks={this.handleShowDeleteKiosksModal}
              onBatchAction={this.handleShowBatchActionPage}
              onTagKiosks={this.handleShowTaggingModal}
              onUpdateDeploymentSet={this.handleShowDeploymentSetUpdateModal}
              onKioskPackageUpdate={this.handleShowUpdateKioskPackageModal}
              tableHeight={BaseLayout.calcTableHeight(allKiosks)}
              hostInfoList={allKiosks}
            />
          </TabPanel>
          <TabPanel>
            <KioskTable
              {...this.props}
              tableTitle='ADM Kiosks'
              isProdKioskTable={true}
              onUpdateKiosks={this.handleShowUpdateKiosksModal}
              onDeleteKiosks={this.handleShowDeleteKiosksModal}
              onBatchAction={this.handleShowBatchActionPage}
              onTagKiosks={this.handleShowTaggingModal}
              onUpdateDeploymentSet={this.handleShowDeploymentSetUpdateModal}
              onKioskPackageUpdate={this.handleShowUpdateKioskPackageModal}
              tableHeight={BaseLayout.calcTableHeight(admKiosks)}
              hostInfoList={admKiosks}
            />
          </TabPanel>
          <TabPanel>
            <KioskTable
              {...this.props}
              tableTitle='In Local'
              onUpdateKiosks={this.handleShowUpdateKiosksModal}
              onDeleteKiosks={this.handleShowDeleteKiosksModal}
              onBatchAction={this.handleShowBatchActionPage}
              onTagKiosks={this.handleShowTaggingModal}
              onUpdateDeploymentSet={this.handleShowDeploymentSetUpdateModal}
              onKioskPackageUpdate={this.handleShowUpdateKioskPackageModal}
              tableHeight={BaseLayout.calcTableHeight(inLocalAdmKiosks)}
              hostInfoList={inLocalAdmKiosks}
            />
          </TabPanel>
          <TabPanel>
            <KioskTable
              {...this.props}
              tableTitle='Colo ServerUrl'
              onUpdateKiosks={this.handleShowUpdateKiosksModal}
              onDeleteKiosks={this.handleShowDeleteKiosksModal}
              onBatchAction={this.handleShowBatchActionPage}
              onTagKiosks={this.handleShowTaggingModal}
              onUpdateDeploymentSet={this.handleShowDeploymentSetUpdateModal}
              onKioskPackageUpdate={this.handleShowUpdateKioskPackageModal}
              tableHeight={BaseLayout.calcTableHeight(heColoAdmKiosks)}
              hostInfoList={heColoAdmKiosks}
            />
          </TabPanel>
          <TabPanel>
            <KioskDeploymentSetTable {...this.props} tableTitle='Kiosk Deployment Set' />
          </TabPanel>
          <TabPanel>
            <BatchActionHistoryTable {...this.props} tableTitle='Batch Action History' />
          </TabPanel>
        </Tabs>

        {this.state.modalView && (
          <ModalContainer onClose={this.handleCloseModal}>
            <ModalDialog onClose={this.handleCloseModal}>{modalComponent}</ModalDialog>
          </ModalContainer>
        )}
      </BaseLayout>
    );
  }
}

export default KioskPage;



// WEBPACK FOOTER //
// ./src/components/pages/KioskPage.js